import React from "react"

import Layout from "../components/layout";
import SEO from "../components/seo";
import PageHeader from '../components/_shared/PageHeader';

const NotFoundPage = () => (
  <Layout>
    <SEO title="404: Not found" />
    <PageHeader title="Page not found"/>
  </Layout>
)

export default NotFoundPage
